import { supabase } from "@/integrations/supabase/client";

/** Where the opt-in happened, for MailerLite-side reporting. */
export type NewsletterSource = "footer" | "signup" | "checkout";

interface SubscribeArgs {
  source: NewsletterSource;
  email?: string;
  name?: string;
  /**
   * Checkout opt-ins pass the Stripe session instead of an email: guest buyers
   * type their address into Stripe's iframe, not into our form, so only the
   * server can resolve it (and it does so only for a session that completed).
   */
  stripeSessionId?: string;
}

/**
 * Subscribe someone to the newsletter. Throws on failure so form call sites can
 * surface an error; fire-and-forget callers (signup, checkout) should catch and
 * ignore — a newsletter hiccup must never derail an account or a payment.
 */
export async function subscribeToNewsletter({
  source,
  email,
  name,
  stripeSessionId,
}: SubscribeArgs): Promise<void> {
  const { error } = await supabase.functions.invoke("newsletter-subscribe", {
    body: { source, email, name, stripeSessionId },
  });
  if (error) throw error;
}
